var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c(
        "section",
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-3" }, [
              _vm._v(
                _vm._s(_vm.$t("message.my_reservations.booking")) +
                  " #" +
                  _vm._s(_vm.order.order_code)
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info mb-3 px-3",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#collapseBox",
                  "aria-expanded": "false",
                  "aria-controls": "collapseBox"
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.home.see_detail_button")) +
                    "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collapse", attrs: { id: "collapseBox" } },
              [
                _c("div", { staticClass: "well" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.my_reservations.reservation_detail")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table text-left" }, [
                    _vm.order.subscription_id
                      ? _c("tr", [
                          _c("td", { attrs: { width: "25%" } }, [
                            _c("span", { staticClass: "text-orange" }, [
                              _c("i", { staticClass: "fal fa-calendar-alt" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.subscription.title")) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.subscription.title")) +
                                " #" +
                                _vm._s(_vm.order.subscription_id) +
                                " - " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.order.subscription.subscription_type
                                  )
                                ) +
                                "\n              "
                            ),
                            _c("div", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.subscription.next_subscription"
                                    )
                                  ) +
                                  ":\n                "
                              ),
                              _vm.order.subscription.subscription_group
                                .cancel === 0
                                ? _c("span", { staticClass: "text-info" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("prettyOnlyDate")(
                                            _vm.order.subscription
                                              .recurring_date
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("message.button.cancel")
                                        ) +
                                        "\n                "
                                    )
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary btn-block",
                                  on: { click: _vm.openSubscriptionOrdersModal }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.subscription.view_all_bookings"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm.order.package_id
                      ? _c("tr", [
                          _c("td", { attrs: { width: "25%" } }, [
                            _c("span", { staticClass: "text-orange" }, [
                              _c("i", { staticClass: "fal fa-layer-group" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.my_reservations.package")
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("message.my_reservations.package")
                                ) +
                                " #" +
                                _vm._s(_vm.order.package_id) +
                                " - " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.order.package.package_type
                                  )
                                ) +
                                "\n              "
                            ),
                            _c("div", { staticClass: "mt-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary btn-block",
                                  on: { click: _vm.openSubscriptionOrdersModal }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.subscription.view_all_bookings"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { colspan: "2" } }, [
                        _vm._v(
                          "\n               #" +
                            _vm._s(_vm.order.order_code) +
                            " - "
                        ),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.serviceParentName(
                                _vm.order.service_id,
                                _vm.globalState.services
                              )
                            )
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { width: "25%" } }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.my_reservations.cleaning_date")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("prettyDate")(_vm.order.cleaning_date))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm.order.service_id === 1
                          ? _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.my_reservations.duration")
                                )
                              )
                            ])
                          : _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.my_reservations.service_type")
                                )
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.order.service_id === 1
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.order.work_hour) +
                                    " " +
                                    _vm._s(
                                      _vm.$tc(
                                        "message.hour",
                                        _vm.order.work_hour
                                      )
                                    ) +
                                    "\n                "
                                ),
                                _vm.$options.filters.orderAdditionalHours(
                                  _vm.order
                                )
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                   " +
                                          _vm._s(
                                            _vm._f("orderAdditionalHours")(
                                              _vm.order
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("multiLangName")(
                                        _vm.globalState.services[
                                          _vm.order.service_id
                                        ]
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { valign: "top" } }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.my_reservations.customer_address")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("multiLangName")(
                                _vm.$t(
                                  _vm.globalState.placeSizes[
                                    _vm.order.place_size_id
                                  ]
                                )
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.order.address))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.my_reservations.remark"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.order.remark))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.summary_total.total"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.order.order_summary_total.total
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("subscription-orders-modal", { ref: "subscriptionOrdersModal" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9d3030c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9d3030c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderSummaryDetail.vue
// module id = 1664
// module chunks = 0